//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex';

import alturaTabelaMixin from '../../../../abbrasil/spa/apuracao/alturaTabelaMixin';
import FiltrosDash from './FiltrosDash';
import { getMoney } from '../../../../../common/functions/helpers';
import {
  prepareResponseData,
} from '../../../../../common/functions/http';
import {
  convertToNumberFormat,
  convertToMoney,
} from '../../../../../common/functions/numeric';

import StatusPassos from '../../../../../shared-components/workflow/StatusPassos';
import Pendencias from './apuracao/pendencias/Pendencias';
import Detalhes from './apuracao/pendencias/Detalhes';
import MetasCrescimento from './apuracao/pendencias/MetasCrescimento';
import PendenciaNegociacao from '../cadeia/apuracao/pendencias/PendenciaNegociacao';
import Apuracao from '../cadeia/apuracao/pendencias/Apuracao';
import PendenciaApuracao from '../cadeia/apuracao/pendencias/PendenciaApuracao';
import ListarEvidencia from '../cadeia/apuracao/pendencias/ListarEvidencia';
import bloqueioSistemaMixin from '../../../../../shared-components/bloqueiosistema/bloqueioSistemaMixin';

export default {
  name: 'ApuracaoTabelaDash',
  mixins: [alturaTabelaMixin, bloqueioSistemaMixin],
  props: {
    contrato: Object,
    pendencias: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      apuracaoGestaoResources: this.$api.apuracaoGestao(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      acordoResources: this.$api.acordo(this.$resource),
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      bloquearConsulta: false,
      statusPassos: {},
      indexPagina: 0,
      itemSelecionado: null,
      objetosSelecionados: [],
      justificativa: '',
      justificativaGrid: null,
      podeAprovar: false,
      esperarRequest: false,
      filtro: {
        status: 'AGUARDANDO_APROVACAO',
      },
      filtroAplicado: {},
      // filtro: {},
      statusNegociacoes: [
        { status: 'EM_CADASTRO', descricao: this.$t('status_entidade.em_cadastro') }, { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
        { status: 'ENCERRADO', descricao: this.$t('label.encerrado') }, { status: 'CANCELADO', descricao: this.$t('label.cancelado') },
        { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }],
      headerApuracao: [
        { text: this.$tc('label.acoes', 1), value: 'acoes', width: 100, sortable: false },
        { text: this.$tc('label.evidencia', 1), value: 'possuiEvidenciaMeta', width: 120, sortable: false },
        { text: this.$tc('label.codigo', 1), value: 'idAcordo', width: 120, sortable: false },
        { text: this.$tc('label.realizado_meta', 1), value: 'realizadoMeta', width: 120, sortable: false },
        { text: this.$tc('label.valor_pagamento', 1), value: 'vlrFinal', width: 120, sortable: false },
        { text: this.$tc('label.valor_negociado', 1), value: 'vlrAssinado', width: 120, sortable: false },
        { text: this.$tc('label.contrato_cliente', 1), value: 'contratoCliente', width: 120, sortable: false },
        { text: this.$t('label.meta'), value: 'vlrMeta', width: 200, sortable: false },
        { text: this.$tc('label.cliente', 1), value: 'nomCliente', width: 250, sortable: false },
        { text: this.$tc('label.acordo'), value: 'descTipoAcordo', width: 150, sortable: false },
        { text: this.$tc('label.solicitante'), value: 'solicitante', width: 250, sortable: false },
        { text: this.$tc('label.descricao', 2), value: 'descricao', width: 250, sortable: false },
        { text: this.$tc('label.marca', 2), value: 'marca', width: 250, sortable: false },
        { text: this.$tc('label.linha_produto', 1), value: 'linhaProduto', width: 250, sortable: false },
        { text: this.$tc('label.familia', 1), value: 'familia', width: 250, sortable: false },
        { text: this.$tc('label.produto', 1), value: 'produto', width: 250, sortable: false },
        { text: this.$tc('label.linha_orcamento', 1), value: 'tipoLinhaOrcamento', width: 250, sortable: false },
      ],
      metasDoAcordo: [],
      modalVisualizarMetas: false,
      headersMetas: [
        { text: this.$t('label.marca'), value: 'nomMarca', sortable: false },
        { text: this.$t('label.linha_produto'), value: 'nomLinhaProduto', sortable: false },
        { text: this.$t('label.familia'), value: 'nomFamilia', sortable: false },
        { text: this.$tc('label.produto', 1), value: 'nomProduto', sortable: false },
        { text: this.$t('label.tipo_linha_orcamento'), value: 'descTipoInvestimento', sortable: false },
        { text: this.$t('label.linha_orcamento'), value: 'descricaoLinhaInvestimento', sortable: false },
        { text: this.$tc('label.valor', 1), value: 'vlrAssinado', sortable: false },
        { text: this.$t('label.valor_reservado'), value: 'vlrReservado', sortable: false },
        { text: this.$t('label.investimento_venda'), value: 'roi', sortable: false },
      ],
      dialog: {
        ref: 'dialog1',
        from: 'blockbtn',
        title: 'Atenção',
        content: 'Deseja realmente aplicar esta ação',
        action: () => ({}),
      },
      title: 'Apurações',
      apuracoes: [],
      totalPage: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      dialogModal: false,
      pendencia: null,
      item: null,
      recriarPaginacao: false,
      esperar: false,
      filtrosCarregados: false,
    };
  },
  computed: {
    hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    },
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    permiteExecucaoMeta() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'APU_UPLOAD' || el === 'APU_DOWNLOAD').length;
    },
    alturaInicial() {
      return window.innerHeight <= 768 ? 400 : this.altura;
    },
  },
  components: {
    Pendencias,
    Detalhes,
    FiltrosDash,
    StatusPassos,
    MetasCrescimento,
    PendenciaNegociacao,
    PendenciaApuracao,
    ListarEvidencia,
  },
  watch: {
    dialogModal(val) {
      if (val) {
        this.preencherPendencias();
      } else {
        this.$emit('Detalhes_close');
      }
    },
    objetosSelecionados() {
      this.requestPermiteAprovar();
    },
    pagination: {
      handler() {
        if (this.filtrosCarregados) {
          this.filtrar();
        }
      },
      deep: true,
    },
  },
  methods: {
    prepareResponseData,
    getMoney,
    openDetalhes(item) {
      this.item = item;
      this.dialogModal = true;
    },
    openModalVisualizarMetas(item) {
      this.showLoading = true;
      this.acordoResources.listarMetas({ id: item.idAcordo })
        .then((response) => {
          this.metasDoAcordo = this.mapearMetas(response.data);
          this.modalVisualizarMetas = true;
        })
        .catch((err) => {
          this.$error(this, err);
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    mapearMetas(metas) {
      return metas.map(meta => ({
        nomLinhaProduto: meta.nomLinhaProduto || '--',
        nomProduto: meta.nomProduto || '--',
        nomFamilia: meta.nomFamilia || '--',
        roi: meta.roi || 0,
        nomMarca: meta.nomMarca || '--',
        vlrAssinado: this.getMoney(meta.vlrAssinado || 0),
        vlrReservado: this.getMoney(meta.vlrReservado || 0),
        descricaoLinhaInvestimento: meta.descricaoLinhaInvestimento || '--',
        descTipoInvestimento: meta.descTipoInvestimento || '--',
      }));
    },
    closeModalVisualizarMetas() {
      this.modalVisualizarMetas = false;
      this.metasDoAcordo = [];
    },
    preencherPendencias() {
      const id = this.item.id;

      this.dashboardApuracaoResources.apuracao({ id })
        .then((response) => {
          this.pendencia = new Apuracao(this.$t('title.negociacao'), this.item.id, this.item.idAcordo, response.data);
        });
    },
    requestAtualizarGrid(filtro) {
      this.pagination.page = 1;
      this.filtroAplicado = { ...filtro };
      this.filtrar();
    },
    recarregarPendencias() {
      this.$emit('Pendencias_recarregar');
      this.refazPaginacao();
    },
    defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa() {
      this.justificativa = null;
      this.$forceUpdate();
    },
    verItem(row) {
      if (row) {
        let rota = null;
        switch (row.codTipoAcordo) {
          case 'FIXO':
            rota = 'verDetalhesNegociacaoFixoFluxo';
            break;
          case 'TABLOIDE':
            rota = 'verDetalhesNegociacaoTabloideFluxo';
            break;
          case 'NEGOCIACAO_PRECO':
            rota = 'verDetalhesNegociacaoPrecoFluxo';
            break;
          case 'POSITIVACAO':
            rota = 'verDetalhesPositivacaoFluxo';
            break;
          case 'CRESCIMENTO':
            rota = 'verDetalhesCrescimentoFluxo';
            break;
          default:
            return;
        }
        this.$router.push({ name: rota, params: { id: row.idAcordo } });
      }
    },
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_APURACAO_TABELA_PAGINA', this.filtro, pagina);
    },
    campoDinheiro(apuracao) {
      if (apuracao.codTipoAcordo === 'POSITIVACAO') {
        return false;
      }
      if (apuracao.tipoMetaBeneficio) {
        return apuracao.tipoMetaBeneficio.indexOf('VOLUME') < 0;
      }
      return true;
    },
    formatacaoRealizadoMeta(apuracao, realizadoMeta) {
      if (this.campoDinheiro(apuracao)) {
        return this.getMoney(realizadoMeta);
      }
      return realizadoMeta;
    },
    refazPaginacao() {
      this.pagination.page = 1;
      this.apuracoes = [];
      this.totalPage = 0;
      this.recriarPaginacao = true;
      setTimeout(() => {
        this.recriarPaginacao = false;
      }, 2E2);
    },
    requestAbrirModalExecucaoMetas(row) {
      this.$emit('APURACAOTABELA_UPLOAD_EVIDENCIA', row);
    },
    requestAbrirAcompanhamento(row) {
      const id = row.id;
      this.workflowPassosResources.statusPassosApuracao({ id }, { id })
        .then((res) => {
          this.statusPassos = res.data;
          this.$refs.modalAcompanhamento.open();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.$refs.modalAcompanhamento.close();
      this.justificativa = '';
    },
    temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    requestBuscarMotivoLog(row) {
      this.apuracaoGestaoResources.buscaJustificativa({ idApuracao: row.id })
        .then((response) => {
          this.justificativaGrid = response.data.justificativa ? response.data.justificativa : 'Sem justificativa';
          this.$refs.modalComentario.open();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    filtrarModal(filtro) {
      if (!this.filtrosCarregados) {
        this.filtrosCarregados = true;
      }
      this.objetosSelecionados = [];
      this.requestAtualizarGrid(filtro);
    },
    requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = 'AGUARDANDO_APROVACAO';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.filtro.meuPassoPendente = true;
      this.filtro.meuPassoAprovado = false;
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao(row = null) {
      if (this.bloqueioSistema) {
        this.mostrarMensagemBloqueio();
        return;
      }

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao(row = null) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoApuracao() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowPassosResources.aprovarPassosApuracao({ idApuracao: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarAprovarSucesso)
          .catch((err) => {
            this.esperarRequest = false;
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowPassosResources.aprovarPassosApuracao({ idApuracao: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.esperarRequest = false;
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.esperarRequest = false;
              this.$error(this, err);
            });
        });
      }
    },
    requestEnviarApuracaoParaAnalise() {
      if (this.itemSelecionado) {
        this.workflowPassosResources.enviarApuracaoAnalise({ idApuracao: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarAnaliseSucesso)
          .catch((err) => {
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowPassosResources.enviarApuracaoAnalise({ idApuracao: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.$error(this, err);
            });
        });
      }
    },
    requestReprovarPassosApuracao() {
      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowPassosResources.reprovarPassosApuracao({ idApuracao: this.itemSelecionado.id },
          { observacao: this.justificativa })
          .then(this.tratarReprovarSucesso)
          .catch((err) => {
            this.esperarRequest = false;
            this.$error(this, err);
          });
      } else {
        this.objetosSelecionados.forEach((el, idx) => {
          this.workflowPassosResources.reprovarPassosApuracao({ idApuracao: el.id },
            { observacao: this.justificativa })
            .then(() => {
              if (idx === (this.objetosSelecionados.length - 1)) {
                this.esperarRequest = false;
                this.recarregarAposAcaoEmMassa();
                this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
              }
            })
            .catch((err) => {
              this.esperarRequest = false;
              this.$error(this, err);
            });
        });
      }
    },
    recarregarAposAcaoEmMassa() {
      this.requestFecharModaisDefault();
      this.requestVoltarTelaInicial();
      this.requestRefreshFilteredList();
    },
    tratarAprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarReprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAnaliseSucesso() {
      this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAlterarSucesso() {
      this.itemSelecionado = null;
      this.requestFecharModaisDefault();
      this.requestRefreshFilteredList();
    },
    buscar(evento) {
      this.limparSelecao();
      this.$emit(evento, this.filtro);
    },
    setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    requestPermiteAprovar() {
      this.podeAprovar = false;
      const lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach((el) => {
          if (!this.ehAprovador(el)) {
            this.podeAprovar = false;
          }
        });
      }
    },
    limparSelecao() {
      this.podeAprovar = false;
      this.objetosSelecionados = [];
    },
    ehAprovador(row) {
      return row.status === 'AGUARDANDO_APROVACAO' && row.aprovador === true;
    },
    fetchProduto(value) {
      value = this.montarFiltroProduto(value);

      return this.produtoResources.listarAtivos(value);
    },
    requestRefreshFilteredList() {
      this.filtrar();
      this.objetosSelecionados = [];
      this.recarregarPendencias();
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao,
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    exibirMeta(row, valor) {
      if (row.metasBeneficios === 'SELLOUT_VALOR' ||
        row.metasBeneficios === 'SELLIN_VALOR') {
        return convertToMoney(valor);
      }
      return convertToNumberFormat(valor);
    },
    exibirPagamento(row, valor) {
      if (row.bonificacao === 'PERCENTUAL') {
        return convertToPercent(valor);
      }
      return convertToMoney(valor);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.requestCarregarApuracoes();
      }, 5E2);
    },
    requestCarregarApuracoes(cb) {
      let filtroRequest = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };
      filtroRequest = { ...filtroRequest, ...this.filtroAplicado };

      Object.keys(filtroRequest).forEach((el) => {
        if (!filtroRequest[el]) {
          delete filtroRequest[el];
        }
      });

      this.carregandoTableApuracoes = true;
      this.dashboardApuracaoResources.listarApuracoes(filtroRequest)
        .then((response) => {
          this.bloquearConsulta = false;
          this.carregandoTableApuracoes = false;

          this.apuracoes = response.data.resposta;
          this.apuracoes.forEach((el, index) => {
            el.index = index;
          });
          this.totalPage = response.data.quantidadeRegistrosPagina;
          if (cb) {
            cb();
          }
          this.pararEsperar();
        }).catch((err) => {
          this.pararEsperar();
          this.bloquearConsulta = false;
          this.carregandoTableApuracoes = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
  },
  mounted() {
    this.filtroCopy = this.filtro;
    this.onResize('apuracao-tabela-dash');
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/ApuracaoTabelaDash.vue?vue&type=script&lang=js&